import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { DomainName, STATUS } from "../../Constants";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { logout } from "./Auth/AuthSlice";



// For Get The Next Page 
const getNextPostsEndpoint  = (args)=>`${DomainName}/page/post?userAccessToken=${args.userToken}&pageId=${args.pageId}&pagingToken=${args.hasNext}` ; 

 export const getNextPostsAPI = createAsyncThunk('page/hasNextpage' , async (args , thunkaPI)=>{
    const {rejectWithValue} = thunkaPI ; 
    try{
        const response = await axios.get(getNextPostsEndpoint(args) , {
            headers : {
                token :args.token
            }
        })
        return response.data ; 
    }catch(err){
        return rejectWithValue(err) ;
    }
})

// For Delete Access Token 
const deleteAcessTokenEndPoint = (args)=>`${DomainName}/auth/pageToken?id=${args.tokenId}` ;

export const deletePageAccessTokenAPI = createAsyncThunk('page/deleteacc' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    console.log(args) ; 
    try{
         axios.delete(deleteAcessTokenEndPoint(args) , {
            headers : {
                token : args.token
            }
        } ,  )
        return args.tokenId
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Reply Comment
const replyCommentEndPoint = (args)=>`${DomainName}/page/reply?commentId=${args.commentId}&userAccessToken=${args.userToken}` ; 

export const replyCommentAPI = createAsyncThunk('page/reply' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        axios.post(replyCommentEndPoint(args) , {
            message : `${args.comment}` , 
        } , {
            headers : {
                token :args.token
            }
        })
        
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Get All Comment Post Of Page 
const getAllCommentsOfPostEndPoint = (args)=>`${DomainName}/page/comments?userAccessToken=${args.userToken}&postId=${args.postId}` ;

export const getAllCommentsOfPostAPI = createAsyncThunk('page/comments' , async (args , thunkAPI) =>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.get(getAllCommentsOfPostEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data.comments;
    }catch(error){
        return rejectWithValue(error);
    }
})

// For Get Posts Page
const getPostPageEndpoint =(token , pageId)=> `${DomainName}/page/post?userAccessToken=${token}&pageId=${pageId}` ;

export const getPostsPageAPI = createAsyncThunk('page/getposts' , async(args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ;
    try{
        const response = await axios.get(getPostPageEndpoint(args.activeToken , args.pageId) , {
            headers : {
                token : args.token
            }
        })
        return response.data
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Add Pagae Token
const addPageTokenEndpoint = `${DomainName}/auth/pageToken` ;

export const addPageTokenAPI = createAsyncThunk('page/addtoken' , async ({token , params} , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.post(addPageTokenEndpoint , 
            {
                pageToken:params.pageToken,
                pageName : params.pageName,
                pageId : params.pageId
            }
         , {
            headers : {
                token  
            }
        })
        console.log(response.data)
        return response.data
    }catch(error){
        return  rejectWithValue(error)
    }
})

// For Get All Token Next Endpoint
const getAllTokenNextEndpoint = (args)=>`${DomainName}/page/token?userAccessToken=${args.userToken}&limit=20&pagingToken=${args.nextToken}` ;
export const getAllTokensNextAPI = createAsyncThunk('getAllTokenNext' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ;
    try{
        const response = await axios.get(getAllTokenNextEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        
        return response.data

    }catch(error){
        return rejectWithValue(error) ; 
    }

})


// For Get All Token Modified
const getAllTokenEndpoint = (args)=>`${DomainName}/page/token?userAccessToken=${args.userToken}&limit=20` ;
export const getAllTokensAPI = createAsyncThunk('getAllToken' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ;
    try{
        const response = await axios.get(getAllTokenEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        
        return response.data

    }catch(error){
        return rejectWithValue(error) ; 
    }

})

// For Get All Tokens
// const getAllTokenEndpoint = `${DomainName}/auth/pageToken` ; 

// export const getAllTokensAPI = createAsyncThunk('getToken' , async(args , thunk)=>{
//     const {rejectWithValue } = thunk ;

//     try{
//         const response = await axios.get(`${getAllTokenEndpoint}` , {
//             headers :{
//                 token : args.token
//             }
//         })
//         return response.data.pageToken
//     }catch(error){
//         return rejectWithValue(error);
//     }

// })



const initialState = {
    pageAccessTokens : [] ,
    status : STATUS.IDLE , 
    pagePosts : [] , 
    statusOfPagePost : STATUS.IDLE  , 
    pageComments : [] , 
    statusOfComments : STATUS.IDLE  ,
    hasNext :"" , 
    hasNextPage : ""

}

const PageSlice = createSlice({
    name : "page" , 
    initialState ,
    reducers : {
        returnToSafeStatus : (state )=>{
            state.status = STATUS.IDLE;
            state.statusOfComments = STATUS.IDLE ; 
            state.statusOfPagePost = STATUS.IDLE ; 
        }
    },extraReducers : (builder)=>{
        builder
        // For Get All Page Token
        .addCase(getAllTokensAPI.fulfilled , (state ,action)=>{
            state.pageAccessTokens = action.payload.pageDetails ;
            state.status = STATUS.SUCCESS ; 
            state.hasNextPage = action.payload?.paging?.next ? action.payload?.paging?.cursors?.after :""

        })
        .addCase(getAllTokensAPI.pending , (state , action )=>{
            state.status = STATUS.LOADDING
        })
        .addCase(getAllTokensAPI.rejected , (state, action )=>{
            if(action.payload.status === 401) { 
                state.status = STATUS.UNAUTHORIZED ; 
                
            }else{
                toast.error("Something Wrong please try again");
                state.status = STATUS.ERROR
            }

            
        })

        // For Add Token 
        .addCase(addPageTokenAPI.fulfilled , (state ,action)=>{
            toast.success("Token Add Successfully")
            state.pageAccessTokens = action.payload.user.page ;
            state.status = STATUS.SUCCESS ;
        })
        .addCase(addPageTokenAPI.pending , (state )=>{
            state.status = STATUS.LOADDING
        })
        .addCase(addPageTokenAPI.rejected , (state, action )=>{
            if(action.payload.status === 401) { 
                state.status = STATUS.UNAUTHORIZED
            }else{
                toast.error("Something Wrong please try again");
                state.status = STATUS.ERROR
            }
        })
        
        // For Get Post Of A Page 
        .addCase(getPostsPageAPI.fulfilled , (state ,action)=>{
            state.pagePosts = action.payload.pageDetails.data ;
            state.statusOfPagePost = STATUS.SUCCESS
            state.hasNext = action.payload.pageDetails?.paging?.next ? action.payload.pageDetails?.paging?.cursors?.after :""

        })
        .addCase(getPostsPageAPI.pending , (state )=>{
            state.statusOfPagePost = STATUS.LOADDING
        })
        .addCase(getPostsPageAPI.rejected , (state , action )=>{
            if(action.payload.status === 401) { 
                state.status = STATUS.UNAUTHORIZED ; 
                useDispatch(logout()) ; 
            }else{
                toast.error("Something Wrong please try again");
                state.status = STATUS.ERROR
            }
        })

        // For Get All comments Of Page
        .addCase(getAllCommentsOfPostAPI.fulfilled, (state , action)=>{
            state.pageComments = action.payload ;
            state.statusOfComments = STATUS.SUCCESS;
        })
        .addCase(getAllCommentsOfPostAPI.pending, (state )=>{
            state.statusOfComments = STATUS.LOADDING;
        })
        .addCase(getAllCommentsOfPostAPI.rejected, (state , action )=>{
            if(action.payload.status == 401) { 
                state.status = STATUS.UNAUTHORIZED
            }else{
                toast.error("Something Wrong please try again");
                state.status = STATUS.ERROR
            } 
        })

        // For Delete Page Token
        .addCase(deletePageAccessTokenAPI.fulfilled , (state ,action)=>{
            state.pageAccessTokens =  state.pageAccessTokens.filter((item)=>{
                return item._id !== action.payload ;
            })
        })

        // For Get The Next Post
        .addCase(getNextPostsAPI.fulfilled , (state , action)=>{
            state.pagePosts.push(...action.payload.pageDetails.data) ; 
            state.hasNext = action.payload.pageDetails?.paging?.next ? action.payload?.pageDetails?.paging?.cursors?.after :""
        })
        .addCase(getNextPostsAPI.rejected , (state , action)=>{
            state.status = STATUS.ERROR ; 
        })

        // For Get The Next Token
        .addCase(getAllTokensNextAPI.fulfilled , (state , action)=>{
            state.pageAccessTokens.push(...action.payload.pageDetails) ; 
            state.hasNextPage = action.payload?.paging?.next ? action.payload?.paging?.cursors?.after :""
        })
    }
})

export default PageSlice.reducer ; 

export const {returnToSafeStatus} = PageSlice.actions ; 

export const getAllPageToken = state => state.PageSlice.pageAccessTokens ; 

export const getHasNextPage = state => state.PageSlice.hasNext ; 

export const getPagePosts = state => state.PageSlice.pagePosts ;

export const getHasNextPageCard = state => state.PageSlice.hasNextPage